import { emptyStringToNull } from 'src/app/shared/helpers/shared-zero-to-null.function';
import { SharedValuePairInterface } from 'src/app/shared/models/shared/shared-value-pair.interface';
import * as ctrlsConstants from 'src/app/shared/_config/ctrls/ctrls-constants';
import { ExtRfrDeliveryDataI } from './rfr-delivery-data.result.ext';
import { RfrDeliveryDataI, RfrDeliveryDataResponseI } from './rfr-delivery-data.result.int';
import { RfrDeliveryDataQueryI } from './rfr-delivery-data.query.int';
import { ExtRfrDeliveryDataQueryI } from './rfr-delivery-data.query.ext';
import { valuePairToValue } from '@softpak/components/spx-helpers';

export const MapRfrDeliveryData = {
    mapQuery: (int: RfrDeliveryDataQueryI): ExtRfrDeliveryDataQueryI => {
       const filters = [];
        if (valuePairToValue(int.deliveryId)) {
            filters.push({
                field: 'deliveryid',
                operator: 'eq',
                value: encodeURIComponent(valuePairToValue(int.deliveryId)),
            });
        }
        return {
            request: {
                filter: JSON.stringify({
                    filter: {
                        logic: 'and',
                        filters: [
                            ...filters
                        ]
                    }
                })
            }
        };
    },
    mapResult: (ext: ExtRfrDeliveryDataI): RfrDeliveryDataResponseI => {
      return {
        deliveries: (ext.response.dsDelivery?.ttDelivery ? ext.response.dsDelivery?.ttDelivery : []).map(delivery => ({
            [ctrlsConstants.ctrlReeferTemperatureMax]: { value: delivery.till_temperature, },
            [ctrlsConstants.ctrlReeferTemperatureMin]: { value: delivery.from_temperature, },
            [ctrlsConstants.ctrlDrains]: MapRfrDeliveryData.mapDrains(emptyStringToNull(delivery.drains)),
            [ctrlsConstants.ctrlHumidity]: { value: delivery.humidity, },
            [ctrlsConstants.ctrlVentilation]: MapRfrDeliveryData.mapVentilation(emptyStringToNull(delivery.ventilation)),
            [ctrlsConstants.ctrlVentilationValue]: { value: emptyStringToNull(delivery.boxref4), },
            [ctrlsConstants.ctrlVentilationUnit]: MapRfrDeliveryData.mapVentilationUnit(emptyStringToNull(delivery.boxref5)),
            [ctrlsConstants.ctrlDefrostInterval]: { value: emptyStringToNull(delivery.boxref3), },
        } as RfrDeliveryDataI))
    };
    },
    mapDrains: (value: string): SharedValuePairInterface => {
      if (value === 'O') {
        return {
            description: 'Open',
            value: 'O'
        };
      }
      if (value === 'C') {
          return {
              description: 'Closed',
              value: 'C'
          };
      }
      if (value === 'N') {
          return {
              description: 'N/A',
              value: 'N'
          };
      }
      return {
          value: null
      };
    },
    mapVentilation(value: string): SharedValuePairInterface {
      if (value === 'O') {
          return {
              description: 'Open',
              value: 'O'
          };
      }
      if (value === 'C') {
          return {
              description: 'Closed',
              value: 'C'
          };
      }
      return {
          value: null
      };
    },
    mapVentilationUnit(value: string): SharedValuePairInterface {
      if (value === 'C') {
          return {
              description: 'm3',
              value: 'C'
          };
      }
      if (value === 'P') {
          return {
              description: '%',
              value: 'P'
          };
      }
      return {
          value: null
      };
    }
};